export const challengeDifficultyModes = [
  {
    id: "easy",
    label: "Easy",
    hardness: 2,
  },
  {
    id: "median",
    label: "Median",
    hardness: 6,
  },
  {
    id: "hard",
    label: "Hard",
    hardness: 10,
  },
] as const;

export function resolveDifficultyLabel(hardness: number) {
  if (hardness >= 8) {
    return "Hard";
  }
  if (hardness >= 4) {
    return "Median";
  }
  return "Easy";
}

export function temperatureToHardness(temperature: number) {
  if (temperature <= 0) {
    return 10;
  }
  if (temperature >= 0.85) {
    return 1;
  }
  const hardness = Math.round(10 - (temperature / 0.85) * 9);
  return Math.max(1, Math.min(10, hardness));
}
